module.exports = __webpack_public_path__ + "static/media/Pool.2dc3bc96.webp";